/*
 * Nombre de la persona con su tienda y zona debajo. Todas las listas del tablero lo usan en vez de
 * escribir el nombre. Desde la etapa 5 el nombre es un enlace a la ficha del empleado
 * (/marcaciones/empleado/:id, pages/admin/attendance/EmployeeProfile.js) solo cuando la fila trae
 * id_empleado; guarda en el estado de la navegación de dónde se vino (state.from) para que "Volver" de la
 * ficha regrese a la misma sección con los mismos filtros. El botón Atrás del navegador también funciona
 * (es un push normal). `row` es cualquier fila con id_empleado, empleado, tienda y zona.
 */
import React from "react";
import {Link, useLocation} from "react-router-dom";

const EmployeeName = ({row}) => {
    const location = useLocation();
    const meta = [row.tienda || 'Sin tienda', row.zona].filter(Boolean).join(' · ');
    return (
        <span className="mc-person">
            {row.id_empleado ? (
                <Link className="mc-person__name mc-person__link" to={{
                    pathname: `/marcaciones/empleado/${row.id_empleado}`,
                    state: {from: `${location.pathname}${location.search}`},
                }}>
                    {row.empleado}
                </Link>
            ) : <span className="mc-person__name">{row.empleado}</span>}
            <span className="mc-person__meta">{meta}</span>
        </span>
    );
};

export default EmployeeName;
